import { FullTextSearchAutocomplete, KnownSearchAutocomplete, KnownSearchRequest } from "Models/Search";
import { BaseSearchRequest, CollectionSearchAutocomplete, CurrentLocationSearchRequest, FullTextSearchRequest, GeoSearchAutocomplete, GeoSearchRequest, ReservationMethod, SavedSearchRequestAutocomplete, SpaceType, VenueGroupSearchAutocomplete, VenueGroupSearchRequest, VenueSearchAutocomplete, VenueSearchRequest } from "Services/API/API";
import exhaustiveCheck from "./exhaustiveCheck";
import moment from "moment";

function getCommonProperties({ amenityIds, maxPrice, minCapacity, minPrice, reservationLengthMinutes, reservationMethod, spaceTypes, startTime }: BaseSearchRequest): Partial<LSCommon.Service.LSWebUI.Models.SearchResultViewModel> {
   return {
      ReservationMethod: reservationMethod == ReservationMethod.Hourly
         ? undefined
         : reservationMethod == ReservationMethod.Monthly
            ? LSCrossTier.WorkspaceReservationMethod.Period
            //not a viable case
            : undefined,
      MinPrice: minPrice,
      MaxPrice: maxPrice,
      AmenityIds: amenityIds,
      WorkspaceCapacity: minCapacity,
      ReservationLengthMinutes: reservationLengthMinutes,
      SpaceTypes: spaceTypes == SpaceType.Any ? undefined : spaceTypes ? spaceTypes.toString() as LSCrossTier.SpaceType : undefined,
      StartTime: startTime ? moment(startTime).format("YYYY-MM-DD") : undefined
   }
}

function getSearchParams(searchRequest: KnownSearchRequest | Exclude<KnownSearchAutocomplete, SavedSearchRequestAutocomplete>): Partial<LSCommon.Service.LSWebUI.Models.SearchResultViewModel> {
   if (searchRequest instanceof FullTextSearchAutocomplete) {
      return {
         Address: searchRequest.fullTextQuery,
         IsFullTextSearch: true
      }
   }
   else if (searchRequest instanceof GeoSearchAutocomplete) {
      return {
         Address: searchRequest.geoQuery
      }
   }
   else if (searchRequest instanceof VenueSearchAutocomplete) {
      return {
         VenueId: searchRequest.venueId
      }
   }
   else if (searchRequest instanceof VenueGroupSearchAutocomplete) {
      return {
         VenueGroupId: searchRequest.venueGroupId
      }
   }
   else if (searchRequest instanceof CollectionSearchAutocomplete) {
      //not a valid case
      return {
         Address: searchRequest.collectionName
      }
   }


   else if (searchRequest instanceof GeoSearchRequest) {
      return {
         ...getCommonProperties(searchRequest),
         Address: searchRequest.address
      }
   }
   else if (searchRequest instanceof CurrentLocationSearchRequest) {
      return {
         ...getCommonProperties(searchRequest),
         IsCurrentLocationSearch: true
      }
   }
   else if (searchRequest instanceof FullTextSearchRequest) {
      return {
         ...getCommonProperties(searchRequest),
         Address: searchRequest.fullTextQuery,
         IsFullTextSearch: true
      }
   }
   else if (searchRequest instanceof VenueSearchRequest) {
      return {
         ...getCommonProperties(searchRequest),
         VenueId: searchRequest.venueId
      }
   }
   else if (searchRequest instanceof VenueGroupSearchRequest) {
      return {
         ...getCommonProperties(searchRequest),
         VenueGroupId: searchRequest.venueGroupId
      }
   }
   else {
      exhaustiveCheck(searchRequest);
      throw new Error("not implemented")
   }
}

export function getSearchUrl(searchRequest: KnownSearchRequest | Exclude<KnownSearchAutocomplete, SavedSearchRequestAutocomplete | CollectionSearchAutocomplete> /* | Guid */ | undefined | null, addRms = false): string {
   if (searchRequest) {
      const searchRequestParams = getSearchParams(searchRequest);
      const searchParams = Object.getOwnPropertyNames(searchRequestParams)
         .filter(key => searchRequestParams[key] != undefined && searchRequestParams[key] !== "")
         .reduce((acc, key) => {
            acc.append(key, searchRequestParams[key]);
            return acc;
         }, new URLSearchParams());

      if (addRms) {
         searchParams.append("rms", "true");
      }
      return `/search?${searchParams.toString()}`;
   }
   else {
      return "/search"
   }
}